export const CellContentType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};
